import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const API = window.__RUNTIME_CONFIG__?.apiBase || window.location.origin;

export default function RetentionRenewalConfirm() {
  const { token } = useParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [info, setInfo] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [outcome, setOutcome] = useState(null); // 'kept' | 'removed'

  useEffect(() => {
    fetch(`${API}/api/auth/retention-renewal/${token}`)
      .then((r) => r.json())
      .then((d) => {
        if (d.error) setError(d.error);
        else setInfo(d);
        setLoading(false);
      })
      .catch(() => {
        setError("Could not connect to the server. Please try again later.");
        setLoading(false);
      });
  }, [token]);

  const respond = async (action) => {
    setSubmitting(true);
    setError("");
    try {
      const res = await fetch(`${API}/api/auth/retention-renewal/${token}/${action}`, { method: "POST" });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error || "Something went wrong");
      setOutcome(action === "confirm" ? "kept" : "removed");
    } catch (e) {
      setError(e.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const containerStyle = {
    minHeight: "100vh",
    background: "#f0f4f8",
    padding: "30px 16px",
    fontFamily: "system-ui, sans-serif",
    display: "flex",
    justifyContent: "center",
  };
  const cardStyle = {
    background: "white",
    borderRadius: 16,
    padding: 32,
    maxWidth: 640,
    width: "100%",
    boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
    height: "fit-content",
  };

  if (loading) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}><p style={{ textAlign: "center", color: "#6b7280" }}>Loading…</p></div>
      </div>
    );
  }

  if (error && !info) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 48 }}>❌</div>
            <h2 style={{ color: "#991b1b" }}>Link Unavailable</h2>
            <p style={{ color: "#6b7280" }}>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (outcome) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 48 }}>{outcome === "kept" ? "✅" : "👋"}</div>
            <h2 style={{ color: outcome === "kept" ? "#166534" : "#374151" }}>
              {outcome === "kept" ? "You're All Set" : "Details Removed"}
            </h2>
            <p style={{ color: "#6b7280" }}>
              {outcome === "kept"
                ? "Thank you — we'll keep your details on file for future opportunities."
                : "Your details have been removed from our Talent Pool, as requested."}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={{ marginTop: 0 }}>Still Want To Hear From Us?</h1>
        <p style={{ color: "#6b7280" }}>
          Hi {info?.candidate_name}, it's been 12 months since you applied with Guud Vision. In line with POPIA, we need to confirm whether you'd still like us to keep your details on file for future opportunities.
        </p>

        {error && <p style={{ color: "#991b1b", fontSize: 14, marginTop: 10 }}>{error}</p>}

        <div style={{ display: "flex", gap: 12, marginTop: 20, flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={() => respond("confirm")}
            disabled={submitting}
            style={{
              flex: 1, minWidth: 200, padding: "14px 20px", borderRadius: 8, border: "none",
              background: submitting ? "#9ca3af" : "#166534",
              color: "white", fontWeight: 700, fontSize: 15,
              cursor: submitting ? "default" : "pointer",
            }}
          >
            Yes, Keep My Details
          </button>
          <button
            type="button"
            onClick={() => respond("decline")}
            disabled={submitting}
            style={{
              flex: 1, minWidth: 200, padding: "14px 20px", borderRadius: 8,
              border: "1px solid #d1d5db",
              background: submitting ? "#f3f4f6" : "white",
              color: "#374151", fontWeight: 700, fontSize: 15,
              cursor: submitting ? "default" : "pointer",
            }}
          >
            No, Remove My Details
          </button>
        </div>
      </div>
    </div>
  );
}
